import { Flex, FormControl, FormLabel, Select, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";

interface LanguageLocaleSectionProps {
  countryId: string;
  uiLang: string;
  releasesLang: string;
  countries: { id: number | string; name: string }[];
  uiLanguages: { id: string; name: string }[];
  allLanguages: { id: string; name: string }[];
  isMobile: boolean;
  onSelect: (field: string, value: string) => void;
}

export function LanguageLocaleSection({
  countryId,
  uiLang,
  releasesLang,
  countries,
  uiLanguages,
  allLanguages,
  isMobile,
  onSelect,
}: LanguageLocaleSectionProps) {
  const [t] = useTranslation();

  return (
    <VStack spacing={5} align="stretch">
      <Text fontSize="xl" fontFamily="heading" fontWeight={600} color="dune.dune">
        {t("screens.settings.languageLocale")}
      </Text>

      <Flex gap={4} direction={isMobile ? "column" : "row"}>
        <FormControl>
          <FormLabel fontSize="sm" color="transparent.white.60">
            {t("screens.settings.country")}
          </FormLabel>
          <Select
            fontSize="16px"
            value={countryId}
            onChange={(e) => onSelect("country_id", e.target.value)}
            placeholder={countryId ? undefined : t("screens.settings.selectCountry")}
          >
            {countries.map((c) => (
              <option key={c.id} value={c.id}>
                {c.name}
              </option>
            ))}
          </Select>
        </FormControl>

        <FormControl isRequired>
          <FormLabel fontSize="sm" color="transparent.white.60">
            {t("screens.settings.interfaceLanguage")}
          </FormLabel>
          <Select
            fontSize="16px"
            value={uiLang}
            onChange={(e) => onSelect("ui_lang", e.target.value)}
          >
            {uiLanguages.map((l) => (
              <option key={l.id} value={l.id}>
                {l.name}
              </option>
            ))}
          </Select>
        </FormControl>
      </Flex>

      <FormControl>
        <FormLabel fontSize="sm" color="transparent.white.60">
          {t("screens.settings.preferredReadingLanguage")}
        </FormLabel>
        <Select
          fontSize="16px"
          value={releasesLang}
          onChange={(e) => onSelect("releases_lang", e.target.value)}
          placeholder={t("screens.settings.anyLanguage")}
        >
          {allLanguages.map((l) => (
            <option key={l.id} value={l.id}>
              {l.name}
            </option>
          ))}
        </Select>
        <Text fontSize="xs" color="transparent.white.30" mt={1}>
          {t("screens.settings.readingLanguageHint")}
        </Text>
      </FormControl>
    </VStack>
  );
}
